import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ModalController } from '@ionic/angular';
import { EditTicketModalComponent } from '../edit-ticket-modal/edit-ticket-modal.component';
import { DeleteTicketModalComponent } from '../delete-ticket-modal/delete-ticket-modal.component';
import { ConfirmDeleteTicketModalComponent } from '../confirm-delete-ticket-modal/confirm-delete-ticket-modal.component';
import { Capacitor } from '@capacitor/core';
import { ShareTicketModalComponent } from '../share-ticket-modal/share-ticket-modal.component';
import { RecentTicket } from 'src/app/models/core/recent-ticket.model';
@Component({
  selector: 'app-ticket-options-modal',
  templateUrl: './ticket-options-modal.component.html',
  styleUrls: ['./ticket-options-modal.component.scss'],
  standalone: false
})
export class TicketOptionsModalComponent {
  @Input() ticket!: RecentTicket;
  @Input() eventId!: number;
  @Input() onTicketDeleted?: () => void;


  constructor(private modalCtrl: ModalController) { }

  get ticketUrl(): string {
    return `${environment.ecommerceDomain}/ticket-verification/${this.ticket?.uuid}`;
  }

  onWatchTicket() {
    const url = this.ticketUrl;
    if (url) {
      window.open(url, '_blank');
      this.modalCtrl.dismiss();
    }
  }

  async onSendTicket() {
    await this.modalCtrl.dismiss();

    const initialBreakpoint = 0.75;

    const modal = await this.modalCtrl.create({
      component: ShareTicketModalComponent,
      componentProps: {
        ticket: this.ticket,
      },
      breakpoints: [0, 0.5, 0.75, 0.95],
      initialBreakpoint,
      cssClass: 'custom-modal-options',
      handle: true,
    });

    await modal.present();
  }

  getInitialBreakpoint(): number {
    const isNativeMobile = Capacitor.isNativePlatform();
    return isNativeMobile ? 0.95 : 0.95;
  }

  async onEditQuote() {
    await this.modalCtrl.dismiss();

    const initialBreakpoint = this.hasPendingEditPetition()
      ? 0.5
      : this.getInitialBreakpoint();

    const modal = await this.modalCtrl.create({
      component: EditTicketModalComponent,
      componentProps: {
        ticket: this.ticket,
        eventId: this.eventId,
        onSuccess: this.onTicketDeleted,
      },
      breakpoints: [0, 0.5, 0.75, 0.95],
      initialBreakpoint,
      cssClass: 'custom-modal-options',
      handle: true,
    });

    await modal.present();
  }

  async onDelete() {
    await this.modalCtrl.dismiss();

    const isConfirmDelete = this.canDeleteTicket();
    const hasPendingDelete = this.hasPendingDeletePetition();

    const component = isConfirmDelete
      ? ConfirmDeleteTicketModalComponent
      : DeleteTicketModalComponent;

    const initialBreakpoint =
      !isConfirmDelete && hasPendingDelete
        ? 0.5
        : isConfirmDelete
          ? 0.75
          : 0.95;

    const componentProps: any = {
      ticket: this.ticket,
      eventId: this.eventId,
    };

    if (this.onTicketDeleted) {
      componentProps.onSuccess = this.onTicketDeleted;
    }

    const modal = await this.modalCtrl.create({
      component,
      componentProps,
      breakpoints: [0, 0.25, 0.5, 0.75, 0.95],
      initialBreakpoint,
      cssClass: 'custom-modal-options',
      handle: true,
    });

    await modal.present();
  }

  canDeleteTicket(): boolean {
    return (
      this.ticket?.assistants_count === 0 && this.ticket?.event?.edit_tickets
    );
  }

  hasPendingPetition(type?: 'edit' | 'delete'): boolean {
    const p = this.ticket.latest_petition;
    if (!p) return false;

    const status = (p.status ?? '').toLowerCase();
    const pType = (p.type ?? '').toLowerCase();

    if (status !== 'pending') return false;
    return type ? pType === type : true;
  }

  hasPendingEditPetition(): boolean {
    return this.hasPendingPetition('edit');
  }

  hasPendingDeletePetition(): boolean {
    return this.hasPendingPetition('delete');
  }

}
